module.exports = __webpack_public_path__ + "img/chipsc.06668f19.webp";